// hooks/useSeitenFarben.js — AO/AKA-Farben für die Punktetafel (23.10.2026, To-do 546).
//
// Quelle: GET /api/modus-display-config/<modus> (öffentlich, die Hallenschirme
// laufen ohne Anmeldung), Feld `schreiber`: dort hat der Server global und den
// Modus schon zusammengelegt — dieselben Werte, die die Modus-Übersicht links
// zeigt. Ohne Modus (Kampf keinem Bracket zugeordnet) gilt global.
//
// Wie useAnzeigeOptik: zuletzt bekannter Stand im Browser (kein Aufblitzen der
// Standardfarben nach dem Neuladen), alle 60 Sekunden neu gefragt.
import { useEffect, useState } from 'react';
import { tafelFarben } from '../lib/seitenFarben';

const SPEICHER = 'tda-seitenfarben:';
const ABSTAND_MS = 60000;

/** Nur Modus-Kennungen wie in brackets.modus_id, sonst global. */
export function modusSchluessel(modus) {
  return typeof modus === 'string' && /^[a-z0-9_]{1,50}$/.test(modus) ? modus : 'global';
}

function gemerkt(m) {
  try { return JSON.parse(localStorage.getItem(SPEICHER + m) || 'null'); } catch { return null; }
}

/** Seitenfarben und Schilder { rot, blau, rotText, blauText, rotName, blauName } für den Modus des laufenden Kampfs. */
export function useSeitenFarben(modus) {
  const m = modusSchluessel(modus);
  const [cfg, setCfg] = useState(() => gemerkt(m));
  useEffect(() => {
    let aus = false;
    setCfg(gemerkt(m));
    const holen = async () => {
      try {
        const r = await fetch(`/api/modus-display-config/${m}`, { cache: 'no-store' });
        if (!r.ok) return;                       // Stand behalten, nicht raten
        const d = await r.json();
        if (aus) return;
        const sch = d?.schreiber && typeof d.schreiber === 'object' ? d.schreiber : {};
        const neu = { aoColor: sch.aoColor || null, akaColor: sch.akaColor || null, aoLabel: sch.aoLabel || null, akaLabel: sch.akaLabel || null };
        try { localStorage.setItem(SPEICHER + m, JSON.stringify(neu)); } catch { /* privater Modus */ }
        setCfg((alt) => (JSON.stringify(alt) === JSON.stringify(neu) ? alt : neu));
      } catch { /* ohne Netz: zuletzt bekannter Stand */ }
    };
    holen();
    const t = setInterval(holen, ABSTAND_MS);
    return () => { aus = true; clearInterval(t); };
  }, [m]);
  return tafelFarben(cfg);
}
